import i18next from 'i18next';
import { z } from 'zod';

export const damageSchema = z.object({
  id: z.string().optional(),
  icon: z.string().nullish(),
  name: z.string().superRefine((data, ctx) => {
    if (!data) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18next.t('damage:damageNameRequired'),
      });
    }
  }),
  severity: z.preprocess(
    (val) => (val === '' || Number.isNaN(val) ? null : val),
    z.number().nullable().superRefine((data, ctx) => {
      if (!data) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: i18next.t('damage:severityRequired'),
        });
      }
    }),
  ),
  color: z.string().nullish(),
  comment: z.string().nullish(),
  index: z.number().nullish(),
  classId: z.number().nullish(),
  active: z.boolean().default(true),
});

export type TDamageSchema = z.infer<typeof damageSchema>;
